import axios from '../../../utils/http/http';
import { triggerNotification } from '../../../utils/NotificationContext';

/**api to save user details if the user is logging in 1st time */
export const saveUserDetails = async (params, pageName) => {
  try {
    const response = await axios.postRequest('/tpo/landing/saveUserDetail', params);
    const successMessage =
      response?.message || pageName == 'edit_modal'
        ? 'Profile updated successfully'
        : 'User details saved successfully!';
    triggerNotification(successMessage, 'success');
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to save user details!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
export const getFunctionsList = async (buName) => {
  try {
    const response = await axios.getRequest(`tpo/landing/getListOfFunctions/${encodeURIComponent(buName)}`);
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch details!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};

export const getRegionChannelTeamList = async (buName, params) => {
  try {
    const response = await axios.getRequest(`/tpo/landing/getTeamRegionChannelList/${encodeURIComponent(buName)}`, {
      params
    });
    return response;
  } catch (error) {
    const errorMessage = error?.message || 'Failed to fetch Team , Region, Channel data!';
    triggerNotification(errorMessage, 'error');
    throw error;
  }
};
